import React, { useEffect, useState } from "react";
import TabelaCustoHH from "./CustoHH";
import TabelaCustosIndiretos from "./CustosIndiretos";

function TabelaPlanejamentoTotal({ dadosPlanejamento, tipo }) {
    const [isFunctionsOpen, setIsFunctionsOpen] = useState(false);
    const [isCostsOpen, setIsCostsOpen] = useState(false);

    const sumCustoIndiretoFuncaoForMonth = (mesAno) => {
        const totalCustoIndireto = dadosPlanejamento.meses[mesAno].total_previsto_indireto || 0;
        const totalFuncao = dadosPlanejamento.meses[mesAno].total_previsto_funcao?.soma_custo_total_funcao || 0;

        return (parseFloat(totalCustoIndireto) + parseFloat(totalFuncao) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const sumCustoIndiretoFuncao = () => {
        let total = 0;
        for (let mesAno in dadosPlanejamento.meses) {
            total += parseFloat(dadosPlanejamento.meses[mesAno].total_previsto_indireto) || 0;
            total += parseFloat(dadosPlanejamento.meses[mesAno].total_previsto_funcao?.soma_custo_total_funcao) || 0;
        }
        return total;   
    };

    const sumValorVenda = () => {
        let total = 0;
        for (let mesAno in dadosPlanejamento.meses) {
            total += parseFloat(dadosPlanejamento.meses[mesAno].valorVenda) || 0;
        }
        return total;
    };

    const toggleFunctions = () => setIsFunctionsOpen(!isFunctionsOpen);
    const toggleCosts = () => setIsCostsOpen(!isCostsOpen);

    return (
        <>
            <div className='mt-3'>
                <div className='table-responsive' style={{maxWidth: "calc(100vw - 270px)"}}>
                    <div className='table-responsive'>
                        <table style={{ backgroundColor: "rgb(225, 234, 243)" }} className='table table-content table'>
                            <thead>
                                <tr>
                                    <th>Tipo</th>
                                    {Object.keys(dadosPlanejamento.meses).map((item, index) => {
                                        return <th key={index}><strong>{item.replace("-", "/")}</strong></th>
                                    })}
                                    <th>Valor Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Total de Custo</td>
                                    {Object.keys(dadosPlanejamento.meses).map((item, index) => {
                                        return <td key={index}><strong>{sumCustoIndiretoFuncaoForMonth(item)}</strong></td>
                                    })}
                                    <td><strong>{parseFloat(sumCustoIndiretoFuncao()).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td>Valor Venda</td>
                                    {Object.keys(dadosPlanejamento.meses).map((item, index) => {
                                        return <td key={index}><strong>{parseFloat(dadosPlanejamento.meses[item].valorVenda || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></td>
                                    })}
                                    <td><strong>{parseFloat(sumValorVenda()).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <h4 className="mt-3" onClick={toggleFunctions} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                <span className='mr-2'>Custo HH</span>
                {isFunctionsOpen ? (
                    '▴'
                ) : (
                    '▾'
                )}
            </h4>
            {isFunctionsOpen && (
                <div className='table-responsive' style={{maxWidth: "calc(100vw - 270px)"}} >
                    <table className='table table-content table table-striped table-bordered'>
                        <thead>
                            <tr>
                                <th>Função</th>
                                {Object.keys(dadosPlanejamento.meses).map((item, index) => {
                                    return <th key={index}><strong>{item.replace("-", "/")}</strong></th>
                                })}
                                <th>Total de horas</th>
                                <th>Taxa de custo</th>
                                <th>Valor Total</th>
                            </tr>
                        </thead>
                        <TabelaCustoHH meses={dadosPlanejamento.meses} tipo={tipo} />
                    </table>
                </div>
            )}
            <h4 className="mt-5" onClick={toggleCosts} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                <span className='mr-2'>Custos Indiretos</span>
                {isCostsOpen ? (
                    '▴'
                ) : (
                    '▾'
                )}
            </h4>
            {isCostsOpen && (
                <div className='table-responsive' style={{maxWidth: "calc(100vw - 270px)"}} >
                    <table className='table table-content table table-striped table-bordered'>
                        <thead>
                            <tr>
                                <th>Tipo</th>
                                <th>Descrição</th>
                                {Object.keys(dadosPlanejamento.meses).map((item, index) => {
                                    return <th key={index}><strong>{item.replace("-", "/")}</strong></th>
                                })}
                                <th>Valor Total</th>
                            </tr>
                        </thead>
                        < TabelaCustosIndiretos meses={dadosPlanejamento.meses} tipo={tipo} />
                    </table>
                </div>
            )}
        </>
    );
}

export default TabelaPlanejamentoTotal;
